import React from 'react';
import PropTypes from 'prop-types';

const IconConnector = ({ width = 16, height = 6, viewBox = '0 0 22 6', color = 'none' }) => {
    return <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height} viewBox={viewBox} fill={color}>
        <path d='M-0.000651121 3C-0.000651121 4.47276 1.19326 5.66667 2.66602 5.66667C4.13877 5.66667 5.33268 4.47276 5.33268 3C5.33268 1.52724 4.13877 0.333333 2.66602 0.333333C1.19326 0.333333 -0.000651121 1.52724 -0.000651121 3ZM15.9993 3C15.9993 4.47276 17.1933 5.66667 18.666 5.66667C20.1388 5.66667 21.3327 4.47276 21.3327 3C21.3327 1.52724 20.1388 0.333333 18.666 0.333333C17.1933 0.333333 15.9993 1.52724 15.9993 3ZM2.66602 3V3.5L18.666 3.5V3V2.5L2.66602 2.5V3Z' fill='#3366FF' />
    </svg>;

};

IconConnector.propTypes = {
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    color: PropTypes.string
};

export default IconConnector;
